import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/CssBaseline": CssBaseline, "@mui/material/BottomNavigation": BottomNavigation, "@mui/material/BottomNavigationAction": BottomNavigationAction, "@mui/icons-material/Restore": RestoreIcon, "@mui/icons-material/Favorite": FavoriteIcon, "@mui/icons-material/Archive": ArchiveIcon, "@mui/material/Paper": Paper, "@mui/material/List": List, "@mui/material/ListItemButton": ListItemButton, "@mui/material/ListItemAvatar": ListItemAvatar, "@mui/material/ListItemText": ListItemText, "@mui/material/Avatar": Avatar } } });
export default ClientProvider;
